export default __webpack_public_path__ + "static/media/amex_image.2bf86b2b.svg";